import { SortOrder, Worklog, WorklogWhereInput } from '../../../generated/graphql'

type ActiveWorklog = Pick<
  Worklog,
  | 'id'
  | 'end_time'
  | 'deleted_at'
  | 'general_activity'
  | 'specific_activity'
  | 'activity_objective'
  | 'start_time'
>

interface ResolveActiveWorklogParams {
  userId?: string
  fetchWorklogs: (where: WorklogWhereInput) => Promise<ActiveWorklog[]>
}

export const ACTIVE_WORKLOG_ORDER_BY = [{ created_at: SortOrder.Desc }]

export function isPendingWorklog(worklog: ActiveWorklog | null | undefined): worklog is ActiveWorklog {
  return Boolean(worklog && worklog.deleted_at == null && worklog.end_time == null)
}

export async function resolveActiveWorklog({
  userId,
  fetchWorklogs,
}: ResolveActiveWorklogParams): Promise<ActiveWorklog | undefined> {
  if (!userId) {
    return undefined
  }

  const pending = await fetchWorklogs({
    user_id: { equals: userId },
    deleted_at: { equals: null },
    end_time: { equals: null },
  })

  return pending.find(isPendingWorklog)
}
